import { Injectable } from '@angular/core';
import {AbstractDatabaseService} from "../../tandem-core/services/abstract-database.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {SpendingPlanChartMetadata} from "../models/spending-plan-chart-metadata";
import {CashFlowChartMetadata} from "../../cash-flows/models/cash-flow-chart-metadata";
import {Timestamp} from "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class SpendingPlanChartMetadataService extends AbstractDatabaseService<SpendingPlanChartMetadata> {

  constructor(protected override afs: AngularFirestore) {
    super('spendingPlanChartMetadata', afs);
  }

  generateSampleChartData(userId: string): SpendingPlanChartMetadata {
    let dates: Date[] = [];
    let currentDate = new Date();

    for (let i = 0; i < 7; i++) {
      // Add a copy of the current date to the array
      dates.push(new Date(currentDate.getTime()));

      // Subtract one month from the current date
      currentDate.setMonth(currentDate.getMonth() - 1);
    }
    return {
      userId: userId,
      dateCreated: Timestamp.now(),
      dateModified: Timestamp.now(),
      charts: [
        {
          spendingPlanId: '1',
          startDate: Timestamp.fromDate(dates[6]),
          endDate: Timestamp.fromDate(dates[5]),
          totalRevenue: 6500.00,
          totalPYFExpenses: 850.00,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2000.00,
          netCashFlow: 450.00
        },
        {
          spendingPlanId: '2',
          startDate: Timestamp.fromDate(dates[5]),
          endDate: Timestamp.fromDate(dates[4]),
          totalRevenue: 7000.00,
          totalPYFExpenses: 1000.00,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2500.00,
          netCashFlow: 300.00
        },
        {
          spendingPlanId: '3',
          startDate: Timestamp.fromDate(dates[4]),
          endDate: Timestamp.fromDate(dates[3]),
          totalRevenue: 8574.38,
          totalPYFExpenses: 1736.84,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 1250.00,
          netCashFlow: 2387.54
        },
        {
          spendingPlanId: '4',
          startDate: Timestamp.fromDate(dates[3]),
          endDate: Timestamp.fromDate(dates[2]),
          totalRevenue: 7184.02,
          totalPYFExpenses: 1235.07,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2500.00,
          netCashFlow: 248.95
        },
        {
          spendingPlanId: '5',
          startDate: Timestamp.fromDate(dates[2]),
          endDate: Timestamp.fromDate(dates[1]),
          totalRevenue: 5864.15,
          totalPYFExpenses: 473.15,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 1250.00,
          netCashFlow: 941.00
        },
        {
          spendingPlanId: '6',
          startDate: Timestamp.fromDate(dates[1]),
          endDate: Timestamp.fromDate(dates[0]),
          totalRevenue: 9748.35,
          totalPYFExpenses: 2674.05,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 3000.00,
          netCashFlow: 874.30
        },
      ]
    }
  }
}
